<template>
  <div class="content--sinoreg">
    <header>
      <h4 class="title pt-3 pl-3">
        Atualizações do sistema
      </h4>
      <h5 class="version py-3 pl-3">
        Atualização versão {{ currentRelease && currentRelease.num_versao }} - {{ formattedDate }}
      </h5>
    </header>

    <b-tabs class="Resumo-border"
            align="left"
            active-nav-item-class="Resumo--tab-active">
      <b-tab :active="tabIndex == 0"
             @click="tabIndex=0"
             @keydown.tab.prevent="tabIndex=0">
        <template v-slot:title>
          Melhorias
        </template>
        <Subcategory :props-data="improvements" />
      </b-tab>

      <b-tab :active="tabIndex == 1"
             @click="tabIndex=1"
             @keydown.tab.prevent="tabIndex=1">
        <template v-slot:title>
          Correções
        </template>
        <Subcategory :props-data="corrections" />
      </b-tab>

      <b-tab :active="tabIndex == 2"
             @click="tabIndex=2"
             @keydown.tab.prevent="tabIndex=2">
        <template v-slot:title>
          Novas funcionalidades
        </template>
        <Subcategory :props-data="newFeatures" />
      </b-tab>

      <b-tab :active="tabIndex == 3"
             @click="tabIndex=3"
             @keydown.tab.prevent="tabIndex=3">
        <template v-slot:title>
          Outros
        </template>
        <Subcategory :props-data="others" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import Subcategory from '@/components/SofiaRei/ReleasesNotes/Subcategory'

  // outros
  import moment from 'moment'
  import { mapGetters } from "vuex"
  
  export default {
    name: 'ReleasesNotes',
    components: {
      Subcategory
    },
    data () {
      return {
        tabIndex: null,
        formattedDate: null,
        improvements: [],
        corrections: [],
        newFeatures: [],
        others: [],
        groupingImprovements: [],
        groupingCorrections: [],
        groupingNewFeatures: [],
        groupingOthers: [],
        subcategory: [],
        objectIndexInArray: null
      }
    },
    computed: {
      ...mapGetters({
        storeReleases: 'releasesNotes/getReleases',
        currentRelease: 'releasesNotes/getCurrentRelease',
        qtdUnreadEntries: 'releasesNotes/getNumberUnreadReleases'
      })
    },
    watch: {
      '$route.params.data': {
        handler () {
          this.clear ()
          this.init () 
        },
        deep: true
      }
    },
    mounted () {
      this.init ()
    },
    destroyed () {
      this.clear ()
    },
    methods: {
      init () {
        // Se houver dados na rota, despacha uma ação do Vuex para salvar esses dados
        if (this.$route.params.data) {
          this.$store
            .dispatch('releasesNotes/setSaveCurrentReleaseData', { data: this.$route.params.data  })
            .then(res => res)
            .catch(err => { throw err })
        }

        // Formatando a data usando o Moment.js
        this.formattedDate = moment(this.currentRelease.created_at).format('DD/MM/YYYY')
        
        // Loop sobre o array usando o método 'reduce'
        this.currentRelease.itemsVersaoRei
          .reduce((acc, newValue, index, array) => {
            // Verifica a categoria do item e o adiciona ao array de agrupamento correspondente
            if (newValue.nome_categoria === 'melhorias') {
              this.groupingImprovements.push(newValue)

            } else if (newValue.nome_categoria == 'correcoes') {
              this.groupingCorrections.push(newValue)

            } else if (newValue.nome_categoria == 'novas_funcionalidades') {
              this.groupingNewFeatures.push(newValue)

            } else {
              this.groupingOthers.push(newValue)
            }
            // Verifica se é o último item do array e, se for, concatena os arrays de agrupamento
            if ((array.length - 1) === index) {
              acc.push(...this.groupingImprovements, ...this.groupingCorrections, ...this.groupingNewFeatures, ...this.groupingOthers)
            }
            return acc
          }, []) 
          .forEach((item, index, array) => {

            // Loop sobre o array resultante
            const otherCategories = item.nome_categoria !== 'melhorias' && item.nome_categoria !== 'correcoes' && item.nome_categoria !== 'novas_funcionalidades'
          
            // Verifica se a categoria do item é "melhoria"
            if (item.nome_categoria == 'melhorias') {
              this.processCategories (item, array, 'melhorias', index, this.improvements, 0)
            } 
            // Verifica se a categoria do item é "correcao"
            if (item.nome_categoria == 'correcoes') {
              this.processCategories (item, array, 'correcoes', index, this.corrections, 1)
            }
            // Verifica se a categoria do item é "nova_funcionalidade"
            if (item.nome_categoria == 'novas_funcionalidades') {
              this.processCategories (item, array, 'novas_funcionalidades', index, this.newFeatures, 2)
            } 
            // Se a categoria não for nenhuma das anteriores, assume que é uma "outra" categoria
            if (otherCategories) {
              this.processCategories (item, array, otherCategories, index, this.others, 3)
            }
          })
      },
      // Função para renderizar subcategorias
      renderSubcategories (item) {
        // Se a subcategoria não estiver presente no array, adiciona uma nova subcategoria
        if (!this.subcategory.length) {   
          this.subcategory.push({
            title: item.nome_subcategoria,
            items: [item.descricao]
          })
        } else {
          // Verifica se o objeto já está presente no array de subcategorias
          const objectIsInArray = this.subcategory.some((obj, index) => {
            // Verifica se o título da subcategoria atual é igual ao título do item
            if (obj.title === item.nome_subcategoria) {
              // Se o título da subcategoria for igual ao título do item, armazena o índice do objeto no array
              // Retorna verdadeiro para indicar que o objeto foi encontrado no array
              this.objectIndexInArray = index
              return true
            }
            // Retorna falso se o objeto não foi encontrado no array
            return false
          })
          // Se a subcategoria já estiver presente no array, adiciona o item à lista de itens da subcategoria
          if (objectIsInArray) {
            this.subcategory[this.objectIndexInArray].items.push(item.descricao)
          } else {
            // Se a subcategoria não estiver no array, adiciona uma nova subcategoria
            this.subcategory.push({
              title: item.nome_subcategoria,
              items: [item.descricao]
            })
          }
        } 
        // Retorna o array de subcategorias atualizado
        return this.subcategory
      },
      // Função para obter o índice de uma categoria específica
      getIndex (data, category) {
        let indice = null
        let indiceOutros = null
        
        data.forEach((item, index) => {
          if (typeof category === 'string' && item.nome_categoria == category) {
            indice = index
          } else if (category) {
            indiceOutros = index
          }
        })
        return {indice, indiceOutros}
      },
      // Função para processar categorias e adicionar subcategorias ao array correspondente
      processCategories (item, array, category, index, arrayCategories, tabIndex) {
        const renderSubcategory = this.renderSubcategories (item)    
        const { indice, indiceOutros } = this.getIndex (array, category) 

        // Verifica se o item pertence à categoria especificada ou à categoria "outras"
        if (index == indice) {
          arrayCategories.push(...renderSubcategory)
          this.tabIndex = tabIndex
          this.subcategory = [] 
          this.objectIndexInArray = null
          
        } else if (index == indiceOutros) {
          arrayCategories.push(...renderSubcategory)
          this.tabIndex = tabIndex
          this.subcategory = []
          this.objectIndexInArray = null
        }
      },
      // Função para limpar as propriedades
      clear () {
        this.tabIndex = null
        this.formattedDate = null
        this.improvements = []
        this.corrections = []
        this.newFeatures = []
        this.others = []
        this.groupingImprovements = []
        this.groupingCorrections = []
        this.groupingNewFeatures = []
        this.groupingOthers = []
      }
    }
  }
</script>

<style lang="scss" scoped>
 @import "@/scss/_components/_resumos";
.title {
  background-color: #074F7F;
  color: #ffff;
  height: 6vh;
  font-weight: 500;
}
.version{
   color: #000000;
   font-weight: 500;
   background-color: #EAEAEA;
}
</style>
